/**
 * @author NikolaV
 */
import { Ajax2 } from '@shared/Ajax';

function get(uuid: string): Promise<IProject> {
    return Ajax2({
        url: kuura.getContextPath() + '/api/1/project/' + uuid,
    }).then(r => r.project);
}

function convertListToTree(projects: IProject[]) {
    const orgs = {};
    projects.forEach(
        p =>
            (orgs[p.organization.uuid] = {
                id: 'org_' + p.organization.uuid,
                uuid: p.organization.uuid,
                name: p.organization.name,
                tolerance: {},
                models: [],
            })
    );

    projects.forEach(p => {
        orgs[p.organization.uuid].models.push({
            id: p.id,
            uuid: p.uuid,
            name: p.name + (p.archived ? ' (' + __('js_admin_projects.archived') + ')' : ''),
            isFile: true,
            orgName: p.organization.name,
        });
    });

    const orgsArray = Object.values(orgs).sort((a: any, b: any) => a.name.localeCompare(b.name));
    orgsArray.forEach((org: any) => {
        org.models = org.models.sort((a: any, b: any) => a.name.localeCompare(b.name));
    });

    return {
        name: 'root',
        id: 0,
        uuid: '0',
        folders: orgsArray,
    };
}

export const ProjectService = {
    get,
    convertListToTree,
};
